import { z } from 'zod'
import { pinDetailsSearchSchema } from '../pinDetails-search-schemas'

/**
 * Shared search schema for the 3 legacy `/pins/**` viewer variants:
 *
 *   /pins/:viewType/noPlan/:pinId?/:tab?/:pinOption?/:page?/:size?/:search?
 *   /pins/:viewType/:planId?/:pinId?/:tab?/:pinOption?/:page?/:size?/:search?/:option?/:subOption?/:id?
 *   /pins/:viewType/:planId?/:pinId?/:tab?/:pinOption?/:search?
 *
 * Path identity (stays in the URL path, NOT here): `viewType`, `planId`, `pinId`.
 *
 * Everything the legacy routes stuffed as optional positional path params is
 * UI/list state that `PlanViewerNew` always read off the query string anyway —
 * it lives in the search now. (`PlanViewerNew` maps these to internal prop
 * names: `tab → stateFilter`, `pinOption → sort`, `pinId → quickFilter`,
 * `page → urlPage`.)
 *
 * The PinDetails overlay params (Card 4.1) are composed in via `.merge()` —
 * the overlap (`option`, `subOption`, `id`) is identical on both sides, so the
 * merge is lossless. `.passthrough()` is intentional during the migration: it
 * can only be dropped once every 4.x card has moved its params into
 * `pinDetailsSearchSchema`.
 */

export const pinsSearchSchema = z
  .object({
    tab: z.string().optional(),
    pinOption: z.string().optional(),
    option: z.string().optional(),
    subOption: z.string().optional(),
    id: z.string().optional(),
    page: z.coerce.number().int().min(0).optional(),
    size: z.coerce.number().int().positive().optional(),
    search: z.string().optional()
  })
  .merge(pinDetailsSearchSchema)
  .passthrough()
